<template>
	<div
		:id="this.$route.params.routerSettings.id"
		:data-dqs-request-id="this.$route.params.routerSettings.requestId"
		:data-start-route="this.$route.params.routerSettings.name"
	>
		<router-view />
	</div>
</template>

<script>
export default {
	name: "App"
};
</script>
